// extracted by mini-css-extract-plugin
export default {"Title":"RQDavCzh","HeadingH1":"Pbl48yFb","HeadingH2":"eZjHzxoQ","HeadingH3":"db4ioETz","isMobile":"F3gjmH92"};